<template>
  <head>

    <meta charset="utf-8" />
    <title>Revenue Team Report | County Management System</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Revenue System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Revenue Team Performance for {{formatSubCountyName(subCountyName)}}</h4>
                  <p class="text-muted mb-0">Period: {{formatDate(dateFrom)}} to {{formatDate(dateTo)}}</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('reports-sub-county')" href="javascript: void(0)">Reports</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('reports-sub-county')" href="javascript: void(0)">Revenue by Sub County</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('reports-sub-counties-details')" href="javascript: void(0)">{{formatSubCountyName(subCountyName)}}</a></li>
                    <li class="breadcrumb-item active">Revenue Team</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Collection</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-success">KES {{numberFormat(amountTotal)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                                                <span class="avatar-title rounded-circle bg-success">
                                                    <i class="bx bx-money font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Active Agents</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(agents.length)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                                                <span class="avatar-title rounded-circle bg-primary">
                                                    <i class="bx bx-user font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Transactions</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalTransactionsCalculated)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                                                <span class="avatar-title rounded-circle bg-info">
                                                    <i class="bx bx-receipt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Avg per Agent</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-warning">KES {{getAveragePerAgent()}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                                                <span class="avatar-title rounded-circle bg-warning">
                                                    <i class="bx bx-trending-up font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- toolbar start -->
          <SubCountyReportsToolBar/>
          <!-- toobar end -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">Revenue Team Performance</h5>
                      <small class="text-muted">Showing {{agents.length}} agents in {{formatSubCountyName(subCountyName)}}</small>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                        <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadAgents()"
                                type="button" class="btn btn-success btn-sm" :disabled="downloading">
                          <i class="bx bx-download"></i> {{download}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control" placeholder="Search agents..." />
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex justify-content-end gap-2">
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">From:</label>
                          <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">To:</label>
                          <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Agent Data...</h5>
                    <p class="text-muted">Please wait while we fetch the latest revenue team performance data.</p>
                  </div>

                  <div v-else-if="agents.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-user-x font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Agents Found</h4>
                      <p class="text-muted">No revenue agents found for the selected criteria. Try adjusting your search or date range.</p>
                      <button @click="clearFilters()" class="btn btn-outline-primary">Clear Filters</button>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 60px;">#</th>
                        <th>Agent</th>
                        <th style="width: 120px;">Zone</th>
                        <th style="width: 120px;">Ward</th>
                        <th class="text-center" style="width: 120px;">Transactions</th>
                        <th class="text-end" style="width: 150px;">Amount Collected</th>
                        <th class="text-center" style="width: 120px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in sortedAgents" :value="item" :key="index">
                        <td class="text-center">
                          <span class="badge bg-light text-dark rounded-pill">{{getItemNumber(index)}}</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="me-3">
                              <div class="avatar-sm">
                                                                    <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                                        {{getAgentInitials(item.names)}}
                                                                    </span>
                              </div>
                            </div>
                            <div>
                              <h6 class="mb-0">
                                <a @click="gotToDetail('reports-sub-county-agent-details',item.idNo,item.names)"
                                   href="javascript: void(0)" class="text-decoration-none">{{capitalizeName(item.names)}}</a>
                              </h6>
                              <small class="text-muted">ID: {{item.idNo}}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span class="fw-medium">{{capitalizeName(item.zone) || 'N/A'}}</span>
                        </td>
                        <td>
                          <span class="fw-medium">{{capitalizeName(item.wardName) || 'N/A'}}</span>
                        </td>
                        <td class="text-center">
                          <span class="fw-medium">{{numberFormat(item.count)}}</span>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-success mb-1">KES {{numberFormat(item.amount)}}</strong>
                            <div class="d-flex align-items-center" style="width: 100px;">
                              <div class="progress flex-grow-1 me-2" style="height: 8px;">
                                <div class="progress-bar" :class="getPerformanceColor(item.amount)"
                                     :style="`width: ${getPercentageOfTotal(item.amount)}%`">
                                </div>
                              </div>
                              <small class="text-muted" style="min-width: 30px;">{{getPercentageOfTotal(item.amount)}}%</small>
                            </div>
                            <small class="text-muted">{{getPerformanceLevel(item.amount)}}</small>
                          </div>
                        </td>
                        <td class="text-center">
                          <button @click="gotToDetail('reports-sub-county-agent-details',item.idNo,item.names)"
                                  type="button" class="btn btn-primary btn-sm">
                            <i class="bx bx-show me-1"></i> View
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="agents.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted">Show</span>
                        <select class="form-select form-select-sm" v-model="pageSize" style="width: auto;">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                        </select>
                        <span class="text-muted">entries</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm justify-content-end mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                              class="page-item" :class="{ active: currentPage === page }">
                            <span v-if="page === '...'" class="page-link">{{ page }}</span>
                            <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <!-- Summary Row -->
                  <div class="row mt-3 pt-3 border-top">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{numberFormat(agents.length)}} Revenue Agents</strong>
                        </div>
                        <div class="text-end">
                          <div><strong>{{numberFormat(totalTransactionsCalculated)}} Transactions</strong></div>
                          <div class="text-success"><strong>KES {{numberFormat(amountTotal)}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Agent Performance Analysis -->
                  <div v-if="agents.length > 0" class="mt-4 pt-3 border-top bg-light">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3 text-primary">
                          <i class="bx bx-trophy me-2"></i>
                          Top 5 Performing Agents
                        </h6>
                        <div v-for="(item, index) in getTopAgents()" :key="index" class="mb-3">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                                                        <span class="fw-medium">
                                                            <span class="badge bg-primary me-2">{{ index + 1 }}</span>
                                                            {{ capitalizeName(item.names) }}
                                                        </span>
                            <strong class="text-success">KES {{ numberFormat(item.amount) }}</strong>
                          </div>
                          <div class="progress" style="height: 12px;">
                            <div class="progress-bar bg-success"
                                 :style="`width: ${getPercentageOfTotal(item.amount)}%`">
                              {{ getPercentageOfTotal(item.amount) }}%
                            </div>
                          </div>
                          <small class="text-muted">
                            {{ numberFormat(item.count) }} transactions • {{ capitalizeName(item.zone) || 'N/A' }}
                          </small>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h6 class="mb-3 text-info">
                          <i class="bx bx-chart-bar me-2"></i>
                          Performance Insights
                        </h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="bx bx-crown text-warning me-2"></i>
                            <strong>{{ getTopAgent()?.names ? capitalizeName(getTopAgent().names) : 'N/A' }}</strong> leads with
                            <span class="text-success fw-bold">{{ getTopAgentPercentage() }}%</span> of total collection
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-calculator text-primary me-2"></i>
                            Average per agent:
                            <span class="fw-bold">KES {{ getAveragePerAgent() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-receipt text-info me-2"></i>
                            Average transactions per agent:
                            <span class="fw-bold">{{ getAverageTransactionsPerAgent() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-trending-up text-success me-2"></i>
                            Revenue per transaction:
                            <span class="fw-bold">KES {{ getRevenuePerTransaction() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-star text-warning me-2"></i>
                            High performers:
                            <span class="fw-bold">{{ getHighPerformers().length }} agents</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- Performance Distribution -->
                    <div class="row mt-4">
                      <div class="col-12">
                        <h6 class="mb-3">Agent Performance Distribution</h6>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="card text-center border-success">
                              <div class="card-body py-3">
                                <h4 class="text-success mb-1">{{ getHighPerformers().length }}</h4>
                                <p class="mb-0 text-muted">High Performers</p>
                                <small class="text-success">>20% above average</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-warning">
                              <div class="card-body py-3">
                                <h4 class="text-warning mb-1">{{ getMediumPerformers().length }}</h4>
                                <p class="mb-0 text-muted">Average Performers</p>
                                <small class="text-warning">Within 20% of average</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-info">
                              <div class="card-body py-3">
                                <h4 class="text-info mb-1">{{ getLowPerformers().length }}</h4>
                                <p class="mb-0 text-muted">Needs Support</p>
                                <small class="text-info">{{'<20% below average'}}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Recommendations -->
                    <div class="row mt-4">
                      <div class="col-12">
                        <div class="alert alert-info">
                          <h6 class="alert-heading">
                            <i class="bx bx-lightbulb me-2"></i>
                            Performance Recommendations
                          </h6>
                          <div class="row">
                            <div class="col-md-6">
                              <ul class="mb-0">
                                <li>Recognize top performer {{ getTopAgent()?.names ? capitalizeName(getTopAgent().names) : '' }} as role model</li>
                                <li v-if="getLowPerformers().length > 0">Provide additional training to {{ getLowPerformers().length }} underperforming agents</li>
                                <li>Share best practices from high performers across the team</li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              <ul class="mb-0">
                                <li>Consider reassigning zones to optimize collection potential</li>
                                <li>Implement performance incentives for consistent achievers</li>
                                <li>Regular coaching sessions for skill development</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>

</template>


<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import SubCountyReportsToolBar from "@/components/reports/collectionbysubcounties/SubCountyReportsToolBar";
import {authUrl, biller, execute, executeDownload, getRight} from "@/api";
import moment from 'moment';

export default {
  name: "ReportsSubCountyAgents",
  components: {SubCountyReportsToolBar, NavigationBar},
  data() {
    return {
      download:'Download Report',
      downloading: false,
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems:0,
      subCountyName:'',
      subCountyID:'',
      dateRange:'',
      dateTo:'',
      dateFrom:'',
      search:'',
      totalAmount:null,
      amountTotal: 0,
      totalAgents:0,
      totalTransactions:0,
      totalTransactionsCalculated: 0,
      agents: [],
    };
  },
  watch: {
    pageSize(newPageSize) {
      this.getAgents()
      const totalItems = this.totalItems;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },

    search(){
      this.currentPage = 1;
      this.getAgents()
    },
  },
  computed:{
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },

    sortedAgents() {
      return [...this.agents].sort((a, b) => Number(b.amount) - Number(a.amount));
    }
  },
  mounted() {
    this.subCountyName = sessionStorage.getItem("subCountyName")
    this.subCountyID = sessionStorage.getItem("subCountyID")
    this.dateTo = sessionStorage.getItem("dateTo")
    this.dateFrom = sessionStorage.getItem("dateFrom")
    this.search = this.subCountyName
    this.totalTransactions = sessionStorage.getItem("totalTransactions")
    this.amountTotal = sessionStorage.getItem("amountTotal")
    this.totalAgents = sessionStorage.getItem("totalAgents")

    this.$watch('dateFrom', function () {
      if (this.dateFrom !== '' || this.dateTo !== '') {
        this.currentPage = 1;
        this.getAgents()
      }
    })

    this.$watch('dateTo', function () {
      if (this.dateFrom !== '' || this.dateTo !== '') {
        this.currentPage = 1;
        this.getAgents()
      }
    })

    this.getAgents()
    this.menuAccess()
  },
  methods: {

    // Helper methods for better UX
    formatSubCountyName(name) {
      if (!name || name === 'undefined') return 'Unknown';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    getAgentInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(word => word.charAt(0)).join('').substring(0, 2).toUpperCase();
    },

    getItemNumber(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },

    getPercentageOfTotal(amount) {
      if (this.amountTotal === 0) return 0;
      return ((Number(amount) / this.amountTotal) * 100).toFixed(1);
    },

    getPerformanceColor(amount) {
      const average = this.amountTotal / this.agents.length;
      const agentAmount = Number(amount);

      if (agentAmount > (average * 1.2)) return 'bg-success';
      if (agentAmount < (average * 0.8)) return 'bg-warning';
      return 'bg-info';
    },

    getPerformanceLevel(amount) {
      const average = this.amountTotal / this.agents.length;
      const agentAmount = Number(amount);

      if (agentAmount > (average * 1.2)) return 'High Performer';
      if (agentAmount < (average * 0.8)) return 'Needs Support';
      return 'Average';
    },

    getAveragePerAgent() {
      if (this.agents.length === 0) return '0';
      return this.numberFormat(Math.round(this.amountTotal / this.agents.length));
    },

    getAverageTransactionsPerAgent() {
      if (this.agents.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalTransactionsCalculated / this.agents.length));
    },

    getRevenuePerTransaction() {
      if (this.totalTransactionsCalculated === 0) return '0';
      return this.numberFormat(Math.round(this.amountTotal / this.totalTransactionsCalculated));
    },

    getTopAgents() {
      return this.sortedAgents.slice(0, 5);
    },

    getTopAgent() {
      if (this.agents.length === 0) return null;
      return this.agents.reduce((max, current) =>
          Number(current.amount) > Number(max.amount) ? current : max
      );
    },

    getTopAgentPercentage() {
      const topAgent = this.getTopAgent();
      if (!topAgent || this.amountTotal === 0) return '0';
      return this.getPercentageOfTotal(topAgent.amount);
    },

    getHighPerformers() {
      const average = this.amountTotal / this.agents.length;
      return this.agents.filter(agent =>
          Number(agent.amount) > (average * 1.2)
      );
    },

    getMediumPerformers() {
      const average = this.amountTotal / this.agents.length;
      return this.agents.filter(agent => {
        const amount = Number(agent.amount);
        return amount >= (average * 0.8) && amount <= (average * 1.2);
      });
    },

    getLowPerformers() {
      const average = this.amountTotal / this.agents.length;
      return this.agents.filter(agent =>
          Number(agent.amount) < (average * 0.8)
      );
    },

    refreshData() {
      this.getAgents();
    },

    clearFilters() {
      this.search = this.subCountyName;
      this.currentPage = 1;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Sub County Agents");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {
            // Success
          })
          .catch(() => {
            console.error("Menu access error");
          });
    },

    getRight(type){
      return getRight(type)
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getAgents()
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getAgents()
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getAgents()
      }
    },

    gotTo(route){
      sessionStorage.setItem("currentPage",route)
      this.$router.push(route);
    },

    gotToDetail(route,idNo,names){
      sessionStorage.setItem("names",names)
      sessionStorage.setItem("idNo",idNo)
      this.$router.push(route);
    },

    formatDate(date) {
      if (!date) return '';
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    capitalizeName(name) {
      if (!name) return '';
      let words = name.split(" ");
      words = words.filter(word => word !== "");
      let capitalizedWords = words.map(word => {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      });
      return capitalizedWords.join(" ");
    },

    getAgents() {
      this.agents.splice(0)
      this.loading = true

      const data = new FormData();
      data.append("function", "getAgents");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.search)
      data.append("subCountyID", this.subCountyID)

      execute(data, authUrl)
          .then((res) => {
            this.loading = false

            if (res.data.success) {
              this.agents = res.data.data.agents || []
              this.totalItems = res.data.data.count?.count || 0
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);

              // Calculate totals from current page data
              this.amountTotal = this.agents.reduce((acc, cur) => {
                let amount = Number(cur.amount) || 0;
                return acc + amount;
              }, 0);

              this.totalTransactionsCalculated = this.agents.reduce((acc, cur) => {
                let count = Number(cur.count) || 0;
                return acc + count;
              }, 0);

            } else {
              console.log("API returned success: false", res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("API Error:", e);
            alert("Failed to load agent data. Please check your connection and try again.");
          });
    },

    downloadAgents(){
      this.downloading = true;
      this.download = "Please wait.."

      const data = new FormData();
      data.append("function", "downloadAgents");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.search)
      data.append("subCountyID", this.subCountyID)

      executeDownload(data,authUrl)
          .then(response => {
            this.download = "Download Report"
            this.downloading = false;

            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = `${this.dateFrom}_to_${this.dateTo}_${this.formatSubCountyName(this.subCountyName)}_agents.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(e => {
            this.download = "Download Report"
            this.downloading = false;
            console.error("Download error:", e);
            alert("Failed to download report. Please try again.");
          });
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    }
  }
}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

.bg-primary-subtle {
  background-color: rgba(13, 110, 253, 0.1) !important;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.progress {
  background-color: #f3f3f3;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.capitalize {
  text-transform: capitalize;
}
</style>